import { useDialogContext } from '../../../contexts/DialogContext';
import { window } from '../../../globals';
import { getAuthorizeServiceURL } from '../../../helpers/services';
import { post } from '../../../redux/api';
import Button from '../../generic/Button/Button';
import { BUTTON_TYPE } from '../../generic/Button/button-constants';
import NavigationButton from '../../generic/Button/NavigationButton';
import Icon, { icons } from '../../generic/Icon';
import Header from '../../shared/settings/SettingsPageHeader';
import Section from '../../shared/settings/SettingsPageSection';

const GithubSettings = () => {
  const { onConfirm } = useDialogContext();

  const disconnectBody = (
    <div>
      <p>
        <b>Are you sure you want to disassociate the current user with the registered GitHub account?</b>{' '}
        (cannot be undone)
      </p>
    </div>
  );

  return (
    <>
      <Header heading="GitHub Login" />
      <Section>
        <Section.Left heading="GitHub Login">
          <Section.Paragraph>
            FOSSA allows users to link a GitHub login to their FOSSA login.
          </Section.Paragraph>
        </Section.Left>
        <Section.Right>
          {!window.user?.github ? (
            <>
              <h4>You are not connected to GitHub</h4>
              <div className="margin-top-lg">
                <NavigationButton
                  to={getAuthorizeServiceURL({
                    vcsHost: 'github',
                    location: window.location.href,
                    serviceConnect: true,
                  })}
                  type={BUTTON_TYPE.SECONDARY}
                  openInNewTab
                >
                  <Icon icon={icons.github} /> Connect to GitHub
                </NavigationButton>
              </div>
            </>
          ) : (
            <>
              <h4>
                You are currently connected{' '}
                {window.user?.github?.name ? (
                  <span>
                    as <b>{window.user?.github?.name}</b>
                  </span>
                ) : (
                  <span>to GitHub</span>
                )}
              </h4>
              <div className="margin-top-lg">
                <Button
                  type={BUTTON_TYPE.SECONDARY}
                  onClick={() => {
                    onConfirm({
                      title: 'Confirm GitHub disconnect',
                      body: disconnectBody,
                      onConfirm: async () => {
                        await post('/api/services/github/disconnectService', {});
                        window.location.reload();
                      },
                    });
                  }}
                >
                  Disconnect
                </Button>
              </div>
            </>
          )}
        </Section.Right>
      </Section>
    </>
  );
};

export default GithubSettings;
